var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageLeftNet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 124,
    viewBox: "0 0 111 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.8906 25H76.8906V101.987H77.8906V25Z",
    fill: "#5E5E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5106 101.258C73.3886 101.258 73.2666 101.223 73.1596 101.151L66.8526 96.9219C66.7106 96.8279 66.6146 96.6799 66.5846 96.5129C66.5526 96.3459 66.5907 96.1739 66.6897 96.0349L70.4737 90.6689C70.6737 90.3839 71.0657 90.3169 71.3517 90.5169C71.6357 90.7179 71.7037 91.1109 71.5027 91.3959L68.0916 96.2339L73.8617 100.104C74.1507 100.298 74.2287 100.69 74.0337 100.979C73.9127 101.16 73.7126 101.258 73.5106 101.258Z",
    fill: "#5E5E5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6016 101.258C83.4886 101.258 83.3746 101.228 83.2716 101.165C82.9746 100.983 82.8826 100.595 83.0646 100.298L85.8046 95.8298L83.0646 91.3618C82.8826 91.0648 82.9746 90.6768 83.2716 90.4948C83.5696 90.3158 83.9576 90.4058 84.1386 90.7028L87.0816 95.5008C87.2056 95.7028 87.2056 95.9578 87.0816 96.1598L84.1386 100.957C84.0206 101.15 83.8136 101.258 83.6016 101.258Z",
    fill: "#5E5E5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0387 107.622H63.6306C63.4046 107.622 63.1956 107.501 63.0836 107.305C62.9716 107.109 62.9716 106.868 63.0866 106.673L65.1886 103.07C65.3636 102.769 65.7516 102.669 66.0506 102.843C66.3506 103.019 66.4537 103.405 66.2777 103.706L64.7296 106.36H72.0407C72.3897 106.36 72.6716 106.642 72.6716 106.991C72.6716 107.34 72.3877 107.622 72.0387 107.622Z",
    fill: "#5E5E5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6086 106.72C83.2966 106.72 83.0256 106.488 82.9836 106.171C82.9396 105.826 83.1837 105.509 83.5277 105.465L89.3897 104.703L89.5186 100.426C89.5296 100.078 89.8206 99.823 90.1676 99.814C90.5166 99.825 90.7896 100.116 90.7796 100.464L90.6346 105.278C90.6246 105.587 90.3916 105.845 90.0856 105.884L83.6896 106.715C83.6636 106.718 83.6356 106.72 83.6086 106.72Z",
    fill: "#5E5E5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7316 115.121C65.5826 115.121 65.4357 115.068 65.3217 114.969C65.1817 114.849 65.1016 114.674 65.1016 114.49V111.617C65.1016 111.268 65.3836 110.986 65.7326 110.986C66.0816 110.986 66.3636 111.268 66.3636 111.617V113.754L74.8866 112.43C75.2426 112.383 75.5546 112.613 75.6076 112.957C75.6606 113.301 75.4256 113.623 75.0816 113.677L65.8306 115.113C65.7956 115.118 65.7636 115.121 65.7316 115.121Z",
    fill: "#5E5E5E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5776 115.769C88.4976 115.769 88.4166 115.754 88.3396 115.722L82.6626 113.41C82.3396 113.279 82.1846 112.911 82.3166 112.588C82.4486 112.265 82.8146 112.108 83.1386 112.242L87.9066 114.183L87.7416 110.249C87.7286 109.901 87.9976 109.607 88.3466 109.592C88.6976 109.569 88.9886 109.848 89.0026 110.196L89.2086 115.11C89.2176 115.324 89.1166 115.529 88.9416 115.653C88.8326 115.73 88.7056 115.769 88.5776 115.769Z",
    fill: "#5E5E5E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5056 115.44C82.2658 115.44 86.1246 111.05 86.1246 105.635C86.1246 100.22 82.2658 95.8298 77.5056 95.8298C72.7455 95.8298 68.8866 100.22 68.8866 105.635C68.8866 111.05 72.7455 115.44 77.5056 115.44Z",
    fill: "#5E5E5E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44519 5.30615L24.4687 88.8393",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0.016076 24.5628C0.016076 24.5628 6.44279 19.497 10.0369 25.4686C10.0369 25.4686 9.49653 17.3618 18.1608 19.1379C18.1608 19.1379 16.9379 10.3293 26.6537 11.1996C26.6537 11.1996 22.7545 2.52613 29.4919 1.68359",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80568 43.6518C3.80568 43.6518 7.719 36.0569 13.5528 40.9066C13.5528 40.9066 18.5674 27.446 32.732 34.9876C32.732 34.9876 28.8378 16.4618 45.5171 16.4419C45.5171 16.4419 38.8963 0.561689 48.3 0",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14267 57.8419C4.14267 57.8419 13.6942 53.0895 17.2386 57.0896C17.2386 57.0896 23.2486 35.107 41.8107 44.8626C41.8107 44.8626 38.105 27.8462 59.3091 20.2741C59.3091 20.2741 50.7373 5.82445 59.3091 1.68359",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.45 0.712402C100.45 0.712402 72.6091 2.27945 71.1785 23.2994C71.1785 23.2994 54.8355 25.9621 47.7767 51.3526C47.7767 51.3526 22.4673 55.2659 21.565 76.0925C21.565 76.0925 -0.595386 80.5498 3.45447 115.894",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7378 85.0583C23.7378 85.0583 6.52665 95.419 4.05166 123",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.92 1.75757C110.92 1.75757 86.7422 7.28772 77.9024 25.4417L5.44519 5.30616L47.7774 51.3526",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLeftNet);
export default __webpack_public_path__ + "static/media/pageLeftNet.b6de301d9867bc2efef35e10fe6d4adc.svg";
export { ForwardRef as ReactComponent };